// Constant standby load under the MODELLED behind-the-meter profile (kW, every
// hour). The backend (demand_shape.apply_base_load) takes it out of each
// month's kWh and runs it every hour; the rest keeps the workday shape, so the
// monthly totals stay as entered. 0 / blank = none. Not used with an imported
// metered profile, which already contains it.

export const BASE_LOAD_LABEL = "Base load, all hours (kW)";

export const BASE_LOAD_HELPER_TEXT =
  "Standby consumption that runs day and night — refrigeration, alarm, router, a compressor on " +
  "standby. It is taken out of each month's kWh and runs every hour; the rest follows the workday " +
  "schedule, so the monthly totals stay as entered. Estimate it from two meter readings, e.g. " +
  "Friday evening to Monday morning: kWh ÷ hours. 0 = none. Not used with an imported profile.";

export const BASE_LOAD_TOO_HIGH_TEXT =
  "The base load needs more energy than the consumption entered for these periods, which are modelled flat:";

const HOURS_PER_MONTH = 8760 / 12;

// Periods whose entered kWh cannot carry the base load (base x hours > kWh).
// A period that covers several months (bi-monthly, quarterly, annual input)
// is checked on its average hours; the backend checks every month exactly.
export function baseLoadShortPeriods(baseKw, periods, valueOf) {
  const base = Number(baseKw);
  if (!Number.isFinite(base) || base <= 0) return [];
  const months = 12 / Math.max(1, periods.length);
  return periods
    .filter((period) => {
      const kwh = Number(valueOf(period));
      return Number.isFinite(kwh) && kwh > 0 && base * HOURS_PER_MONTH * months > kwh;
    })
    .map((period) => period.label);
}
